import { call, put, select } from 'redux-saga/effects';

import { SpacesSiteUrls } from '~src/spacesPlatform/components/spaceComponents/SpacesSiteUrls';
import { openBlankWindow, setWindowLocation } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { requestFailed } from '../../bootstrap/redux/actions/RequestFailedAction';
import { siteUrlsSelector } from '../../bootstrap/redux/selectors/SiteUrlsSelectors';
import { Messages } from '../../codegen/Localize';
import { ContentDraftStatus } from '../../drafts/serverApi/types/ContentDraft';
import { EditFlowReduxAction } from '../actions/EditFlowReduxAction';
import { getFlowDetailInfo } from '../FlowsSagaHelpers';
import { FlowDetailInfo } from '../models/FlowInfo';

export function* handleEditFlow(action: EditFlowReduxAction) {
  let newWindow: Window = null;
  try {
    const flow = action.flow;
    const urls: SpacesSiteUrls = yield select(siteUrlsSelector);
    newWindow = openBlankWindow();
    if (flow.draftStatus === ContentDraftStatus.unpublished) {
      setWindowLocation(newWindow, urls.flowEditorDraftUrl(flow.draftLuid));
    } else {
      const flowDetailInfo: FlowDetailInfo = yield call(getFlowDetailInfo, flow.id);
      const flowLuid = flowDetailInfo.luid;
      setWindowLocation(newWindow, urls.flowEditorFlowPath({flowLuid}));
    }
  } catch (e) {
    yield put(requestFailed(e, Messages.errorUnknown()));
  }
}
